import { Magnetic } from "../../styles";
/**
 * Represents media queries
 */
export const MediaQueryConstants = {
    EXTRA_LARGE: `(min-width: ${Magnetic.layoutBreakpointXl})`,
    LARGE: `(max-width: ${Magnetic.layoutBreakpointXl}) and (min-width: ${Magnetic.layoutBreakpointLg})`,
    MEDIUM: `(max-width: ${Magnetic.layoutBreakpointLg}) and (min-width: ${Magnetic.layoutBreakpointMd})`,
    SMALL: `(max-width: ${Magnetic.layoutBreakpointMd}) and (min-width: ${Magnetic.layoutBreakpointSm})`,
    EXTRA_SMALL: `(max-width: ${Magnetic.layoutBreakpointSm})`
};
//# sourceMappingURL=MediaQueryConstants.js.map